/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import type Person from 'linced-app/models/person';

// Proto: people.Audit.
export default class Audit extends Model {
  declare [Type]: 'people/audit';

  // createTime is when the resource was created in seconds from the epoch.
  @attr('number')
  declare createTime: number | undefined;

  // date contains the date the attendance was recorded against as a string
  // to facilitate filtering.
  @belongsTo('person', { async: true, inverse: null })
  declare personId: AsyncBelongsTo<Person>;

  @alias('personId')
  declare person: AsyncBelongsTo<Person>;

  @belongsTo('person', { async: true, inverse: null })
  declare authorId: AsyncBelongsTo<Person>;

  @alias('authorId')
  declare author: AsyncBelongsTo<Person>;

  // oldMoeFte has no default: field-level-audit.hbs:192 shows blank for no
  // value, and 0 shows as a real FTE.
  @attr('number')
  declare oldMoeFte: number | undefined;

  // newMoeFte has no default: field-level-audit.hbs:196 shows blank for no
  // value, and 0 shows as a real FTE.
  @attr('number')
  declare newMoeFte: number | undefined;

  @attr('string', { defaultValue: '' })
  declare oldMoeType: string;

  @attr('string', { defaultValue: '' })
  declare newMoeType: string;

  // reason provides a description as to why the attendance edit was made.
  @attr('string', { defaultValue: '' })
  declare reason: string;
}
